import React, { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { resolveAudio } from "../../lib/api";

export const AudioPreview = ({ src, testid }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  if (!src) return null;
  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (a.paused) {
      document.querySelectorAll("audio").forEach((el) => { if (el !== a) el.pause(); });
      a.play();
    } else a.pause();
  };
  return (
    <>
      <button type="button" onClick={toggle} data-testid={testid} title="Preview audio"
        className="h-8 w-8 grid place-items-center rounded-full bg-[#C8A97E]/15 text-[#C8A97E] hover:bg-[#C8A97E] hover:text-[#0B0C10] transition-colors shrink-0">
        {playing ? <Pause size={14} /> : <Play size={14} className="ml-0.5" />}
      </button>
      <audio ref={ref} src={resolveAudio(src)} preload="none"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
    </>
  );
};
